/**
 * Keeps the PDP sticky bar quantity control in sync with the main product form
 * quantity input (single source of truth for POST: name="quantity" + form id).
 *
 * If the theme has no quantity_selector block, there is no associated input — we add a hidden
 * input inside the product form so sticky + ATC still submit the chosen quantity.
 */
(function () {
  function resolveMainQuantityInput(scope, formId) {
    var candidates = scope.querySelectorAll('input[name="quantity"]');
    var i;
    for (i = 0; i < candidates.length; i++) {
      if (candidates[i].getAttribute('form') === formId) {
        return candidates[i];
      }
    }
    var form = document.getElementById(formId);
    if (!form) {
      return null;
    }
    for (i = 0; i < candidates.length; i++) {
      if (form.contains(candidates[i])) {
        return candidates[i];
      }
    }
    var existing = form.querySelector('input[name="quantity"][data-yodeyma-sticky-qty-fallback="1"]');
    if (existing) {
      return existing;
    }
    var hidden = document.createElement('input');
    hidden.type = 'hidden';
    hidden.name = 'quantity';
    hidden.value = '1';
    hidden.setAttribute('data-yodeyma-sticky-qty-fallback', '1');
    form.appendChild(hidden);
    return hidden;
  }

  function initStickyQuantitySync(stickyRoot) {
    if (!stickyRoot || stickyRoot.hasAttribute('data-yodeyma-qty-sync')) {
      return;
    }

    var formId = stickyRoot.getAttribute('form-id');
    if (!formId) {
      return;
    }

    var stickyInput = stickyRoot.querySelector('[data-sticky-quantity]');
    if (!stickyInput) {
      return;
    }

    var scope = stickyRoot.closest('.product-wrapper') || document;
    var mainInput = resolveMainQuantityInput(scope, formId);

    if (!mainInput) {
      return;
    }

    stickyRoot.setAttribute('data-yodeyma-qty-sync', '');

    var syncing = false;

    function syncToMain() {
      if (syncing) {
        return;
      }
      syncing = true;
      if (stickyInput.value !== mainInput.value) {
        mainInput.value = stickyInput.value;
        mainInput.dispatchEvent(new Event('input', { bubbles: true }));
        mainInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      syncing = false;
    }

    function syncToSticky() {
      if (syncing) {
        return;
      }
      syncing = true;
      if (mainInput.value !== stickyInput.value) {
        stickyInput.value = mainInput.value;
        stickyInput.dispatchEvent(new Event('input', { bubbles: true }));
      }
      syncing = false;
    }

    stickyInput.value = mainInput.value;

    stickyInput.addEventListener('input', syncToMain);
    stickyInput.addEventListener('change', syncToMain);
    mainInput.addEventListener('input', syncToSticky);
    mainInput.addEventListener('change', syncToSticky);

    /**
     * Theme product-form builds FormData on submit; +/- on the sticky sometimes leaves the main
     * input at 1 if events did not run or input-number state is out of sync. Flush right before
     * submit (capture runs before the theme's bubble listener).
     */
    function flushStickyIntoMain(e) {
      if (!stickyInput) {
        return;
      }

      /**
       * Important: avoid overwriting the main PDP quantity when the user submits via the
       * main Add to cart button. Only flush sticky → main when the sticky ATC is the submitter
       * (or was clicked), otherwise a hidden sticky input sitting at value="1" can reset qty.
       */
      if (e && e.type === 'submit') {
        var submitter = e.submitter || document.activeElement;
        if (!submitter || !stickyRoot.contains(submitter)) {
          return;
        }
      }
      var v = String(stickyInput.value == null ? '' : stickyInput.value).trim();
      if (v === '') {
        v = '1';
      }
      var formNode = document.getElementById(formId);
      var list = scope.querySelectorAll('input[name="quantity"]');
      for (var j = 0; j < list.length; j++) {
        var inp = list[j];
        if (inp.getAttribute('form') !== formId && !(formNode && formNode.contains(inp))) {
          continue;
        }
        if (inp.value !== v) {
          inp.value = v;
        }
        if (inp.getAttribute && inp.getAttribute('is') === 'input-number') {
          try {
            inp.quantity = v;
          } catch (e) {
            /* ignore */
          }
        }
        inp.dispatchEvent(new Event('input', { bubbles: true }));
        inp.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    var formEl = document.getElementById(formId);
    if (formEl && !formEl.hasAttribute('data-yodeyma-sticky-qty-flush')) {
      formEl.setAttribute('data-yodeyma-sticky-qty-flush', '');
      formEl.addEventListener('submit', flushStickyIntoMain, true);
    }

    var stickySubmit = stickyRoot.querySelector(
      '#StickyAddToCart[form], button[form][type="submit"][data-product-add-to-cart-button]'
    );
    if (stickySubmit) {
      stickySubmit.addEventListener('click', flushStickyIntoMain, true);
    }
  }

  function initAll() {
    document.querySelectorAll('product-sticky-form[form-id]').forEach(initStickyQuantitySync);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
